<div class="developers">
    <app-new-header></app-new-header>

    <div class="section_one" style="background-image: url('../../../../assets/img/dotted-map.jpg')">
        <div class="overlay">
            <div class="left">
                <div>HUIOSPAY FOR DEVELOPERS</div>
                <h3>We make an impact in ways that improve life far beyond everyone else</h3>
                
                <div class="buttons">
                    <button>Become Merchant</button>
                    <!-- <button>View Documentation</button> -->
                </div>
            </div>
            <div class="right">
                <img src="../../../../assets/img/developer.svg" alt="">
            </div>
        </div>
    </div>

    <div class="section_divider">
        <img src="../../../../assets/img/spiralone.png" alt="" class="spiral">
    </div>


    <div class="section_four">
        <div class="top rev">
            <div class="cell">
                <h3 class="why">Create well-documented APIs with great payment experiences</h3>
                <div class="subtext">
                    Developers get to love our well-documented APIs that let you create everything from simple projects to complex financial
                    products for all customers. If you can think or visualize it, you can create or build it with HuiosPay.
                </div>
                <div class="items">
    
                    <ul>
                        <li>Collect one-time and recurring payments from your website or app.</li>
                        <li>Make quick transfers.</li>
                        <li>Verify customer identities.</li>
                        <li>Fast & easy integrations.</li>
                        <li>Effective customer support & service.</li>
                    </ul>
    
                </div>
            </div>
            <div class="top-image">
                <img src="../../../../assets/img/developer1.png" alt="">
            </div>
        </div>
        <div class="top bottom">
            <div class="cell">
                <h3 class="why">Seamless payment experience for our customers</h3>
                <div class="subtext">Our goal is to expose our customers to possibilities of modern, frictionless and painless payments. Our ongoing
                commitment to efficiency manifests in our ability to provide a wide variety of payment options for your business needs.</div>


                <div class="items">
                    <ul>
                        <li>Debit/Credit Card</li>
                        <li>Mobile Money</li>
                        <li>Bank Transfer</li>
                    </ul>
                    <ul>
                        <li>POS</li>
                        <li>USSD</li>
                        <li>Visa QR</li>
                    </ul>
                </div>
    
            </div>
            <div class="top-image">
                <img src="../../../../assets/img/section4one.jpg" alt="">
            </div>
        </div>
    </div>


    <div class="section_four">
        <div class="top rev">
            <div class="cell">
                <h3 class="why">Accept payments on all shopping platforms</h3>
                <div class="subtext">HuiosPay's automated and manual anti-fraud systems protect you from fraudulent activities and associated chargeback
                claims.</div>
            
            </div>
            <div class="top-image">
                <img src="../../../../assets/img/posontable.png" alt="">
            </div>
        </div>
        <div class="top bottom">
            <div class="cell">
                <h3 class="why">Verify your customer's identity</h3>
                <div class="subtext">Need to verify that your customers are who they say they are? Our verification APIs allow you to do this in various ways
                possible.</div>

                <div class="items">
                    <ul>
                        <li>Verify customer identity with a bank account number.</li>
                        <li>Verify customer identity with a phone number.</li>
                        <li>Verify customer identity with a BVN.</li>
                    </ul>
                </div>
    
            </div>
            <div class="top-image">
                <img src="../../../../assets/img/mansnapping.png" alt="">
            </div>
        </div>
    </div>

    <div class="section_four">
        <div class="top rev">
            <div class="cell">
                <h3 class="why">Understand customer purchase methods & patterns</h3>
                <div class="subtext">Your HuiosPay dashboard surfaces useful customer insights from your payment data.</div>
            
                <div class="items">
                    <ul>
                        <li>See who your top customers are.</li>
                        <li>Check out your new and returning customers.</li>
                    </ul>
                </div>
            
            </div>

            <div class="top-image">
                <img src="../../../../assets/img/mansmilling.png" alt="">
            </div>
        </div>
        <div class="top bottom">
            <div class="cell">
                <h3 class="why">Monitor your business performance on the go</h3>
                <div class="subtext">Sign up to HuiosPay and track your most important business metrics on any of your mobile devices. Monitor information
                such as customer information, sales, success rates, etc.</div>


                <div class="items">
                    <ul>
                        <li>Sign up to HuiosPay in minutes.</li>
                        <li>Get invoices from your phone's comfort.</li>
                        <li>Easily lookup any transactions.</li>
                        <li>Get notified on important updates.</li>
                    </ul>
                </div>
            
            </div>
            <div class="top-image">
                <img src="../../../../assets/img/womansmilling.png" alt="">
            </div>
        </div>
    </div>


    <div class="section_seven" style="background-image: url('../../../../assets/img/section7.jpg');">
        <div class="join">
            <h3>Join the community of smart business decision makers</h3>
    
    
    
            <button>Open a Merchant Account</button>
        </div>
    </div>
    
    <app-new-footer></app-new-footer>
</div>

